import { makeAxiosObservable } from "@delanobgt/admin-core/util/epics/AxiosObservable";
import { Epic } from "redux-observable";
import { concat, of, timer } from "rxjs";
import {
  catchError,
  debounceTime,
  filter,
  map,
  switchMap,
  takeUntil,
} from "rxjs/operators";
import Interactors from "src/core/Interactors";
import { RootState } from "src/redux";
import { isActionOf } from "typesafe-actions";

import { actions, TActions } from "./ducks";

export const pollingPaymentConfirmationPackageFlow: Epic<
  TActions,
  TActions,
  RootState
> = (action$, state$) =>
  action$.pipe(
    filter(isActionOf(actions.pollingStartRequested)),
    debounceTime(750),
    switchMap(() =>
      timer(0, state$.value.paymentConfirmationPackage.refreshDelay).pipe(
        switchMap(() =>
          concat(
            of(actions.fetchAsync.request(null)),
            makeAxiosObservable((signal) =>
              Interactors.paymentConfirmationPackage.getPaymentConfirmationPackage(
                state$.value.paymentConfirmationPackage.pagination,
                state$.value.paymentConfirmationPackage.filter,
                state$.value.paymentConfirmationPackage.sorts,
                signal
              )
            ).pipe(
              map(([data, meta]) => actions.fetchAsync.success({ data, meta })),
              catchError((error) => of(actions.fetchAsync.failure(error)))
            )
          )
        ),
        takeUntil(
          action$.pipe(filter(isActionOf(actions.pollingStopRequested)))
        )
      )
    )
  );

const paymentConfirmationPackageFlows = [pollingPaymentConfirmationPackageFlow];

export default paymentConfirmationPackageFlows;
